import React from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { UndraggableImage } from 'components/shared/UndraggableImage';
import { useScrollToAnchor } from 'hooks/useScrollToAnchor';

interface Props {
  src: string;
  title: string;
  code: string;
  anchor?: string;
}

const AnimatedButton = motion(Button);

export const ProductButton = React.memo(
  ({ title, code, src, anchor }: Props) => {
    const textShadow = React.useMemo(
      () =>
        'rgb(255 255 255) -1px -1px 5px, rgb(255 255 255) 1px -1px 5px, rgb(255 255 255) 1px 1px 5px, rgb(255 255 255) -1px 1px 5px',
      [],
    );

    const scrollToAnchor = useScrollToAnchor();

    return (
      <AnimatedButton
        onClick={scrollToAnchor(anchor || code)}
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="flext-start"
        backgroundColor="rgba(255,255,255,0)"
        pl={3}
        pr={3}
        pt={3}
        pb={3}
        m={2}
        textAlign="left"
        whiteSpace="break-all"
        borderRadius={16}
        width={{
          base: 'calc(100% - 24px)',
          sm: 'calc(50% - 24px)',
          md: 'calc(50% - 24px)',
          lg: 300,
          xl: 340,
        }}
        height={100}
        _focus={{ border: 'none' }}
        whileTap={{ scale: 0.95, backgroundColor: 'rgba(255,255,255,0.382)' }}
        whileHover={{ backgroundColor: 'rgba(255,255,255,0.382)' }}
        transition={{ duration: 0.1 }}
      >
        <UndraggableImage
          src={src}
          width={{
            base: '80px',
            sm: '40px',
            md: '100px',
            lg: '60px',
            xl: '80px',
          }}
          mr={4}
        />
        <Flex flexDirection="column">
          <Text
            fontSize={{ base: 16, md: 18, lg: 16, xl: 18 }}
            color="orange.700"
            fontWeight="bold"
            textShadow={textShadow}
            userSelect="none"
            onSelect={(e) => e.preventDefault()}
          >
            {title}
          </Text>
          <Text
            fontSize={{ base: 14, md: 16, lg: 14, xl: 16 }}
            color="orange.700"
            fontWeight="bold"
            textShadow={textShadow}
            userSelect="none"
            onSelect={(e) => e.preventDefault()}
          >
            {code}
          </Text>
        </Flex>
      </AnimatedButton>
    );
  },
);
